// extracted by css-extract-rspack-plugin
export default {"header":"Xe3sJhXUmP0rmSPR","title":"fTtZMUUxUJwVqMcG","summary":"iF8XlE1ErmgNhJWV","search":"kadsp1B_WwYEnB5r"};